import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import MediaQuery from 'react-responsive'
import FontIcon from 'material-ui/FontIcon'
import breakpoints from '../styles/breakpoints'
import {
  uiMobileSearchOn,
  uiMobileSearchOff,
  uiToggleMobileSearch,
} from '../actions'
import { themeColors } from '../styles/theme'

const styles = {
  button: {
    position: 'fixed',
    top: '90px',
    right: '10px',
    zIndex: 100000,
  },
  iconStyleOff: {
    color: 'black',
  },
}

class MobileSearchButton extends PureComponent {
  componentWillUnmount() {
    this.props.uiMobileSearchOff()
  }

  render() {
    const { mobileSearchActive, uiToggleMobileSearch } = this.props

    return (
      <FloatingActionButton
        onClick={uiToggleMobileSearch}
        mini={true}
        style={styles.button}
        backgroundColor={
          mobileSearchActive ? themeColors.lightBackground : undefined
        }
        iconStyle={mobileSearchActive ? styles.iconStyleOff : undefined}>
        <FontIcon className="material-icons">search</FontIcon>
      </FloatingActionButton>
    )
  }
}

const mapStateToProps = state => ({
  mobileSearchActive: state.ui.mobileSearch,
})

const MobileSearchButtonContainer = connect(mapStateToProps, {
  uiMobileSearchOn,
  uiMobileSearchOff,
  uiToggleMobileSearch,
})(MobileSearchButton)

export default () => (
  <MediaQuery maxWidth={breakpoints.xs}>
    <MobileSearchButtonContainer />
  </MediaQuery>
)



// WEBPACK FOOTER //
// ./src/common/MobileSearchButton.js